export interface OperacaoValida {
  pk?: string;
  id?: string;
  notaFiscal?: string[];
  status?: string;
  origem?: string;
  localizacao?: string;
  dataInicio?: string;
}

export interface OperacoesValidaResponse {
  Items: OperacaoValida[];
  Count: number;
}

export function validarOperacoesValida(payload: any): OperacoesValidaResponse {
  if (!payload || !Array.isArray(payload.Items) ||
      !Number.isInteger(payload.Count) || payload.Count < 0 ||
      payload.Count !== payload.Items.length ||
      payload.Items.some((item: any) => !item || typeof item !== 'object' || Array.isArray(item))) {
    throw new Error('Resposta de operacoes Valida invalida.');
  }
  return payload;
}